import { defineComponent as _defineComponent } from 'vue';
import { ref } from "vue";
import SelectObjectStore from "@/components/ObjectStore/SelectObjectStore.vue";
export default /*#__PURE__*/ _defineComponent({
    __name: 'WorkflowSelectPreferredObjectStore',
    props: {
        invocationPreferredObjectStoreId: { default: null }
    },
    emits: ["updated"],
    setup(__props, { emit }) {
        const props = __props;
        const selectedObjectStoreId = ref(props.invocationPreferredObjectStoreId);
        const newDatasetsDescription = "The default storage location for the outputs of this workflow invocation";
        const defaultOptionTitle = "Use Defaults";
        const defaultOptionDescription = "If the history has a preference set, that will be used. If instead, you've set an option in your user preferences - that will be assumed to be your default selection. Finally, the Galaxy configuration will be used.";
        async function handleSubmit(preferredObjectStoreId) {
            selectedObjectStoreId.value = preferredObjectStoreId;
            emit("updated", preferredObjectStoreId);
        }
        return { __sfc: true, props, emit, selectedObjectStoreId, newDatasetsDescription, defaultOptionTitle, defaultOptionDescription, handleSubmit, SelectObjectStore };
    }
});
